import { useQuery } from 'react-query';
import { getPCDetailsForWarehouse, GetPCDetailsForWarehouseResponse } from 'src/utils/Queries';

export function usePCDetails( warehouseId: string | undefined )
{
    return useQuery<GetPCDetailsForWarehouseResponse, Error>(
        ['pc-details', warehouseId],
        () => getPCDetailsForWarehouse( warehouseId! )!,
        { enabled: !!warehouseId, staleTime: 300000 }
    );
}
